import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { Timeline } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';

import { TimelineResponse } from 'src/core/types/servicehistory.types';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-timeline',
  imports: [Timeline, CardModule, ButtonModule, TranslocoModule],
  templateUrl: './timeline.component.html',
  styleUrl: './timeline.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TimelineComponent {

  @Input() timeline: TimelineResponse;

}
